import { useContext, useState } from "react";
import { textes } from "../../constants/textes";
import { useParams } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import SiteInfos from "../../components/sites/siteinfos";



export default function ViewSites() {
    // states
    let codesite = useParams();
    const [page, setPage] = useState(0);
    const { user } = useContext(UserContext);

    const displayPages = () => {
        if (page === 0) {
            return <SiteInfos codesite={codesite.code} />;
        }
        //  else {
        //     return <TypeConges />;
        // }
    }

    // affichages
    return (
        <div className="container-fluid">
        <h1 className="h4 mb-4 font-weight-bold text_primary"><i className="fa fa-building mr-1"></i> Sites</h1>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.siteinfoslabel}</span>
                </button>
                {/* <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.shiftemployelabel}</span>
                </button> */}
            </div>
            {displayPages()}
        </div>
    )

}